export default __webpack_public_path__ + "static/media/icebreaker_logo_transparent.5829c96f.png";